import { render } from "./404.vue?vue&type=template&id=c16e661a&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=c16e661a&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16e661a"]])

export default __exports__